import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'src/store/index';
import { selectClassUserByClassId } from 'src/store/model/class_user';

export type State = {
  loading: boolean;
  search: {
    params: SearchParams.UserPager;
    ids: string[];
  };
};

export const adapter = createEntityAdapter<Model.UserPager>({
  selectId: (model) => model.id,
});

const { reducer, actions } = createSlice({
  name: 'user_pagers',
  initialState: adapter.getInitialState<State>({
    loading: false,
    search: {
      params: {},
      ids: [],
    },
  }),
  reducers: {
    updateEntities(state, action: PayloadAction<Model.UserPager[]>) {
      adapter.upsertMany(state, action);
    },
    updateEntity(state, action: PayloadAction<Model.UserPager>) {
      adapter.upsertOne(state, action);
    },
    removeEntity(state, action: PayloadAction<string>) {
      adapter.removeOne(state, action.payload);
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    updateSearch(state, action: PayloadAction<State['search']>) {
      state.search = action.payload;
    },
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.user_pager,
);

export const selectOnePagerByClassUserId = createSelector(
  selectClassUserByClassId,
  selector.selectAll,
  (classUser, user_pagers) => {
    return user_pagers.filter((p) => p.class_user_id === classUser?.id);
  },
);

export const selectPublicPager = createSelector(
  selector.selectAll,
  (state: RootState, class_id?: string) => class_id,
  (state: RootState) => state.model.user_pager.search,
  (state: RootState) => state.model.user_pager.entities,
  (pagers, class_id, search, entities) => {
    if (search.params?.q) {
      return search.ids.map((id) => entities[id]!);
    }
    return pagers.filter(
      (p) => p.is_public && p.class_user.class_id === class_id,
    );
  },
);

export const selectShowDemoDayPager = createSelector(
  selector.selectAll,
  (state: RootState, class_id?: string) => class_id,
  (state: RootState) => state.model.user_pager.search,
  (state: RootState) => state.model.user_pager.entities,
  (pagers, class_id, search, entities) => {
    if (search.params?.q) {
      return search.ids.map((id) => entities[id]!);
    }
    return pagers.filter(
      (p) => p.show_to_demo_day && p.class_user.class_id === class_id,
    );
  },
);

export { reducer };
export default actions;
